import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = window.locale || "";

export const cancellationReasons = [
  {
    checked: false,
    id: "reason_1",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_1"
    ),
  },
  {
    checked: false,
    id: "reason_2",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_2"
    ),
  },
  {
    checked: false,
    id: "reason_3",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_3"
    ),
  },
  {
    checked: false,
    id: "reason_4",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_4"
    ),
  },
  {
    checked: false,
    id: "reason_5",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_5"
    ),
  },
  {
    checked: false,
    id: "reason_6",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_6"
    ),
  },
  {
    checked: false,
    id: "reason_7",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_7"
    ),
  },
  {
    checked: false,
    id: "reason_8",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_8"
    ),
  },
  {
    checked: false,
    id: "reason_9",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_9"
    ),
  },
  {
    checked: false,
    id: "reason_10",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_10"
    ),
  },
  {
    checked: false,
    id: "reason_11",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_11"
    ),
  },
  {
    checked: false,
    id: "reason_12",
    text: i18n.translate(
      "admin_pages.settings.billing.cancel_modal.cancellation_reason_12"
    ),
  },
];
// Translated only what is not a competitor name
export const cancellationCompetitors = [
  "AwardCo/Nectar",
  "CrewHu",
  "In House",
  i18n.translate(
    "admin_pages.settings.billing.cancel_modal.competitor_industry_specific"
  ),
  "Kazoo",
  "Lattice",
  "Motivosity",
  i18n.translate(
    "admin_pages.settings.billing.cancel_modal.competitor_payroll_system"
  ),
  "Elevated",
  "Hoot House",
  "Jaapi.store",
  i18n.translate(
    "admin_pages.settings.billing.cancel_modal.competitor_unknown"
  ),
  i18n.translate(
    "admin_pages.settings.billing.cancel_modal.competitor_no_replace"
  ),
  "Workplace",
  "Paylocity",
  "RecognizeApp",
  "Xoxoday",
  "Redzone",
  "Zoho",
];

export const defaultBillingPageData = {
  billingType: "",
  chargebeeInfo: {
    billingAddress: {},
    card: {},
  },
  chargebeeSite: "",
  companyBlocklisted: false,
  companyId: "",
  showSuperAdminFeature: false,
  subscriptionStatus: "",
  subscriptionTrialDisplay: "",
  subscriptionType: "",
};

export const defaultRecentInvoicesData = {
  billingType: "",
  companyId: "",
  lineItems: [],
  netTermDays: 0,
  refillAmount: 0,
  refillAmountDisplay: "--",
  refillThresholdDisplay: "--",
  rewardBalanceDisplay: "--",
  rowCount: 0,
};

export const defaultRewardBalanceData = {
  lineItems: [],
  rowCount: 0,
};

export const defaultRewardBillingData = {
  companyId: "",
  displayBillingType: "",
  rewardBalance: "",
  subscriptionAutoCollection: null,
  userCount: null,
};

export const defaultSubscriptionData = {
  companyBlocklisted: false,
  costPerPeriod: "--",
  costPerPeriodLabel: "Cost per period",
  discountLabel: "Discount",
  errorMessage: undefined,
  hasProratedBilling: false,
  isAnnual: false,
  isMonthly: false,
  paymentDueLabel: "Next payment due",
  paymentMethodOnFile: undefined,
  planLabel: "",
  showDiscount: false,
  subscriptionCadence: 0,
  subscriptionCostPerPeriod: "--",
  subscriptionSavingsPerYearOnAnnual: "--",
  subscriptionStatus: "",
  subscriptionTotalCostPerMonthOnAnnual: "--",
  subscriptionTotalCostPerYearOnAnnual: "--",
  subscriptionType: "--",
  trialEndDate: undefined,
  trialing: false,
  userIsCompanyAdmin: false,
  usersCostBreakdown: "--",
  usersLabel: "Users",
};

export const defaultMessageOptions = {
  isOpen: false,
  message: "",
  type: "info",
};

export const genericErrorMessage = i18n.translate(
  "admin_pages.activity.something_went_wrong"
);

export const recentInvoicesTableHeaders = [
  {
    accessor: "dateInvoiceCreated",
    align: "left",
    paddingLeft: "50px",
    text: i18n.translate("admin_pages.activity.table_headers.issue_date"),
  },
  {
    accessor: "displayDescription",
    align: "left",
    text: i18n.translate("admin_pages.activity.table_headers.description"),
  },
  {
    accessor: "displayAmount",
    align: "right",
    paddingRight: "50px",
    text: i18n.translate("admin_pages.activity.table_headers.amount"),
  },
  {
    accessor: "statusBox",
    align: "left",
    paddingLeft: "50px",
    text: i18n.translate("admin_pages.activity.table_headers.status"),
  },
  {
    accessor: "downloadIcon",
    align: "center",
    paddingRight: "25px",
    text: i18n.translate("admin_pages.activity.table_headers.download_invoice"),
  },
  {
    accessor: "makePaymentButton",
    align: "center",
  },
];

export const rewardBalanceTableHeaders = [
  {
    accessor: "date",
    align: "left",
    text: i18n.translate("admin_pages.activity.table_headers.date"),
    width: "250px",
  },
  {
    accessor: "description",
    align: "left",
    text: i18n.translate("admin_pages.activity.table_headers.description"),
  },
  {
    accessor: "displayAmount",
    align: "right",
    text: i18n.translate("admin_pages.activity.table_headers.amount"),
    width: "150px",
  },
  {
    accessor: "displayBalance",
    align: "right",
    text: i18n.translate("admin_pages.activity.table_headers.balance"),
    width: "150px",
  },
  {
    accessor: "downloadIcon",
    align: "center",
    srOnly: "Download Column Header",
    text: "",
    width: "85px",
  },
];
